import Vue from 'vue'
import container from './container'

Vue.component('container', container)
Vue.component('js-pagination', () => import('./js-pagination'))
Vue.component('pagination', () => import('./pagination'))
Vue.component('bv-select', () => import('./bv-select'))
Vue.component('dict-select', () => import('./dict-select'))
Vue.component('uploader-image', () => import('./upload/uploader-image'))

Vue.component('region-cascader', () => import('./region-cascader'))

// 物料选择组件 Start
// 1.分类物料选择表格
Vue.component('choose-category-material', () =>
  import('./choose-category-material')
)
// 2.分类物料选择表格弹框
Vue.component('choose-category-material-dialog', () =>
  import('./choose-category-material/dialog.vue')
)

// 3.物料选择表格
Vue.component('choose-material', () => import('./choose-material'))
// 4.物料选择表格弹框
Vue.component('choose-material-dialog', () =>
  import('./choose-material/dialog.vue')
)

// 面料选择组件
Vue.component('choose-fabric', () => import('./choose-fabric'))
Vue.component('choose-fabric-dialog', () =>
  import('./choose-fabric/dialog.vue')
)
// 样品选择组件
Vue.component('choose-sample', () => import('./choose-sample'))
Vue.component('choose-sample-dialog', () =>
  import('./choose-sample/dialog.vue')
)
// 样品库存选择组件
Vue.component('choose-sample-stock', () => import('./choose-sample-stock'))
Vue.component('choose-sample-stock-dialog', () =>
  import('./choose-sample-stock/dialog.vue')
)
// 订单识别码组件
Vue.component('identify-input', () => import('./identify-code'))
//成分维护信息组件
Vue.component('choose-master-attribute-dictionary', () =>
  import('./choose-master-attribute-dictionary')
)

// 表格头部筛选组件
Vue.component('filter-content', () => import('./filter-content'))

// 分类级联组件
Vue.component('category-cascader', () => import('./category-cascader'))
